import { createApi } from '@reduxjs/toolkit/query/react'
import { CalculatorInfo } from '@g17eco/types/carbon-calculator';
import { axiosBaseQuery } from '@api/axiosQuery';
import { transformResponse } from '@api/g17ecoApi';


export const carbonCalculatorsApi = createApi({
  reducerPath: 'carbonCalculatorsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['carbon-calculators'],
  endpoints: (builder) => ({
    getCarbonCalculatorsList: builder.query<CalculatorInfo[], void>({
      transformResponse,
      query: () => ({
        url: '/o/carbon-calculators',
        method: 'get',
      })
    }),
  }),
});

export const { useGetCarbonCalculatorsListQuery } = carbonCalculatorsApi;
